function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './RadioButtonsList.css';
import React, { useEffect, useState } from 'react';
const RadioButtonsList = props => {
  const {
    required = false,
    value: contextValue = '',
    label = 'label',
    name = 'name',
    updateContext,
    rtl = false,
    patternInvalidMessage = 'validateError',
    options = [],
    validate,
    isBoolean
  } = props;
  const [inValid, setInValid] = useState(false);
  const onChangeEvent = value => {
    const stringValue = isBoolean ? value : value.toString();
    if (stringValue.length) required && setInValid(!(stringValue && stringValue.length));
    updateContext({
      [name]: _objectSpread(_objectSpread({}, props), {}, {
        valid: required && !!stringValue,
        value: stringValue
      })
    });
  };
  useEffect(() => {
    if (validate) {
      const stringValue = contextValue.toString();
      required && setInValid(!(stringValue && stringValue.length));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validate]);
  return /*#__PURE__*/React.createElement("fieldset", {
    className: `${rtl ? rtlStyles : ltrStyles} ${styles}`
  }, /*#__PURE__*/React.createElement("legend", {
    className: "accessibility-hidden-text"
  }, label), label && /*#__PURE__*/React.createElement("p", {
    className: "body-small wiz__label"
  }, label, required && /*#__PURE__*/React.createElement("span", {
    className: "form-label__marker"
  }, " * ")), /*#__PURE__*/React.createElement("div", {
    className: "d-flex "
  }, options.map((props, index) => {
    const {
      lookupId,
      name
    } = props;
    const label = rtl ? name.ar || '' : name.en || '';
    const checked = isBoolean ? contextValue == lookupId : contextValue.length && contextValue.toString() == lookupId;
    return /*#__PURE__*/React.createElement("span", {
      key: lookupId,
      className: "form-label__container"
    }, /*#__PURE__*/React.createElement("input", {
      className: `fp__radio ${inValid ? ' invalid-field' : ''}`,
      type: "radio",
      onChange: () => {
        onChangeEvent(lookupId);
      },
      tabIndex: 0,
      onKeyPress: event => {
        if (event.key === 'Enter' || event.key === 'NumpadEnter') {
          event.currentTarget.checked = !event.currentTarget.checked;
          event.preventDefault();
          onChangeEvent(lookupId);
        }
      },
      checked: checked,
      name: label,
      id: label,
      value: lookupId
    }), label && /*#__PURE__*/React.createElement("label", {
      htmlFor: label,
      className: `form-label__radio `
    }, label));
  })), inValid && /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("p", {
    className: "text-input__error"
  }, patternInvalidMessage)));
};
const styles = "si1keph";
const ltrStyles = "l12syft1";
const rtlStyles = "rhoh7s6";
export default RadioButtonsList;